<template>
  <div class="selector">
    <div class="control has-icons-left">
      <div class="select is-medium" style="margin-bottom: 7px;">
        <select v-model="currentParty">
          <option v-for="party in parties" v-bind:value="party.name">
            {{ party.name }}
          </option>
        </select>
      </div>
      <span class="icon is-small is-left">
  <img :src="partyLogo" width="20px;" alt="">
</span>
      <div class="versionselect clearfix">
        <p v-if="loading">Loading</p>
        <a v-for="version in versions" class="navbar-item" v-on:click="setCurrentVersion(version)"
           v-bind:class="{ 'is-active': isCurrentVersion(version) }"
           v-lazy-container="{ selector: 'img' }">

          <img class="image-version" :data-src="getImageLink(version)"
          />
        </a>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'Selector',
    data: function () {
      return {
        imagesLoaded: 0
      }
    },
    computed: {

      parties() {
        return this.$store.state.parties;
      },
      loading() {
        return false;
      },
      partyLogo() {
        var filename = this.currentParty;

        // replace umlauts and make it lower case
        filename = filename.toLowerCase();
        filename = filename.replace(/ä/g, 'ae');
        filename = filename.replace(/ö/g, 'oe');
        filename = filename.replace(/ü/g, 'ue');
        filename = filename.replace(/ß/g, 'ss');

        return '/static/' + filename + '.svg';
      },
      // get versions (for bg images) of current party
      versions() {
        return this.$store.getters.getVersions;
      },
      currentParty: {
        get() {
          // when the current Party changes all blocks/lines need to be set to the new parties default
          this.$store.commit('setDefaultLines');
          return this.$store.state.currentParty;
        },
        set(value) {
          this.$store.state.currentParty = value;
          this.$store.commit('setDefaultVersion');
        }
      },
      currentVersion: {
        get() {
          return this.$store.state.currentVersion;
        },
        set(value) {
          this.$store.state.currentVersion = value;
        }
      }

    },
    methods: {
      getImageLink(url) {
        var image = require('../assets/' + url);
        return image;
      },
      isCurrentVersion(version) {
        return (version == this.currentVersion);
      },
      setCurrentVersion(version) {
        this.currentVersion = version;
      }
    }
  }
</script>

<style scoped>
  .selector {
    margin-bottom: 30px;
  }

  h1,
  h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  nav,
  nav a {
    min-height: 44px;
  }

  nav a {
    padding: 0 15px;
  }

  .is-active {
    background-color: #EEE !important;
  }

  .control {
    width: auto;
    float: left;
    margin-right: 20px;
    padding-bottom: 15px;
  }

  .versionselect {
    background-color: #FFF;
    display: inline-block;
    border-radius: 3px;
    overflow: hidden;
    border: 1px rgb(219, 219, 219) solid;
    transition: width 300ms;
  }

  .versionselect a {
    float: left;
    padding: 3px 10px;
    display: inline-block;
  }

  .versionselect a img {
    min-height: 38px;
    position: relative;
    margin-top: -8px;
    top: 7px;
    transition: all 1s;
    transition-delay: 500ms;
    opacity: 0;
  }
  img[lazy=loading] {
    opacity: 0;
    transition-delay: 500ms;
  }
  img[lazy=error] {
    opacity: 0;
    transition-delay: 500ms;
  }
  img[lazy=loaded] {
    opacity: 1 !important;
  }

</style>



// WEBPACK FOOTER //
// Selector.vue?7209f8bc